/**
 * en-GB messages added by Phase 4 task W28 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w28EnGB = {
    'p4dp.title': 'Data protection',
    'p4dp.description': 'Find a person, export or erase their data, place legal holds and see how long data is kept.',
    'p4dp.tabs': 'Data protection sections',
    'p4dp.tab.requests': 'Requests',
    'p4dp.tab.find': 'Find a person',
    'p4dp.tab.jobs': 'Exports and erasures',
    'p4dp.tab.holds': 'Legal holds',
    'p4dp.tab.retention': 'Retention',
    'p4dp.find.title': 'Find a person',
    'p4dp.find.help': 'Search every part of CloudSign. Tick the records that belong to the person; nothing is guessed.',
    'p4dp.find.name': 'Name',
    'p4dp.find.email': 'Email address',
    'p4dp.find.phone': 'Phone number',
    'p4dp.find.search': 'Search',
    'p4dp.find.useName': 'Also match free-text records (for example parcels) that use exactly this name',
    'p4dp.find.needOne': 'Enter a name (at least 2 letters), an email address or a phone number.',
    'p4dp.find.results': 'Matching records',
    'p4dp.find.none': 'No records found for those details.',
    'p4dp.find.truncated': 'There are more matches than can be shown. Narrow the search.',
    'p4dp.find.tick': 'Tick {label}',
    'p4dp.find.selectAll': 'Select all',
    'p4dp.find.selected': '{count} selected',
    'p4dp.find.col.record': 'Record',
    'p4dp.find.col.module': 'Area',
    'p4dp.find.col.when': 'Date',
    'p4dp.find.reason': 'Reason',
    'p4dp.find.reasonHint': 'Why you are doing this, for the audit log. For example "Subject access request, 12 Oct".',
    'p4dp.find.export': 'Export their data',
    'p4dp.find.erase': 'Erase their data',
    'p4dp.find.hold': 'Place a legal hold',
    'p4dp.find.exportStarted': 'Export started. It appears under Exports and erasures.',
    'p4dp.find.reasonNeeded': 'Give a reason first.',
    'p4dp.erase.title': 'Erase personal data',
    'p4dp.erase.help': 'This is what erasing the ticked records would do. Erasure cannot be undone.',
    'p4dp.erase.module': 'Area',
    'p4dp.erase.erased': 'Removed',
    'p4dp.erase.anonymised': 'Made anonymous',
    'p4dp.erase.kept': 'Kept',
    'p4dp.erase.why': 'Why it is kept',
    'p4dp.erase.holdsTitle': 'Legal holds stop this erasure',
    'p4dp.erase.holdsHelp': 'These holds cover some of the records. Release them first, or the erasure will be blocked.',
    'p4dp.erase.confirmLabel': 'Type {word} to confirm',
    'p4dp.erase.confirmWord': 'ERASE',
    'p4dp.erase.confirmButton': 'Erase now',
    'p4dp.erase.cancel': 'Cancel',
    'p4dp.erase.started': 'Erasure started.',
    'p4dp.erase.previewing': 'Checking what would be removed…',
    'p4dp.job.progress': 'Progress',
    'p4dp.job.status.queued': 'Waiting to start',
    'p4dp.job.status.running': 'Running',
    'p4dp.job.status.done': 'Finished',
    'p4dp.job.status.failed': 'Failed',
    'p4dp.job.status.blocked': 'Blocked by a legal hold',
    'p4dp.job.kind.export': 'Export',
    'p4dp.job.kind.erasure': 'Erasure',
    'p4dp.job.col.kind': 'Type',
    'p4dp.job.col.person': 'Person',
    'p4dp.job.col.status': 'Status',
    'p4dp.job.col.started': 'Started',
    'p4dp.job.col.by': 'By',
    'p4dp.job.filterKind': 'Type',
    'p4dp.job.open': 'Details',
    'p4dp.job.openFor': 'Details for {person}',
    'p4dp.job.empty': 'No exports or erasures yet.',
    'p4dp.job.title': 'Job details',
    'p4dp.job.reason': 'Reason',
    'p4dp.job.finished': 'Finished',
    'p4dp.job.download': 'Download the export',
    'p4dp.job.downloadUntil': 'Available until {when}',
    'p4dp.job.expired': 'This export is no longer available.',
    'p4dp.job.results': 'Result by area',
    'p4dp.job.moduleDone': 'Done',
    'p4dp.job.modulePending': 'Not yet done',
    'p4dp.job.progressCount': '{done} of {total} areas done',
    'p4dp.job.error': 'What went wrong',
    'p4dp.holds.title': 'Legal holds',
    'p4dp.holds.help': 'Records under a hold are never deleted, whatever the retention rules or an erasure say.',
    'p4dp.holds.new': 'Place a hold',
    'p4dp.holds.label': 'Label',
    'p4dp.holds.reason': 'Reason',
    'p4dp.holds.recordsCount': '{members} people, {visits} visits',
    'p4dp.holds.placedBy': 'Placed by {name}, {when}',
    'p4dp.holds.releasedBy': 'Released by {name}, {when}',
    'p4dp.holds.active': 'Active',
    'p4dp.holds.released': 'Released',
    'p4dp.holds.release': 'Release hold',
    'p4dp.holds.releaseFor': 'Release hold {label}',
    'p4dp.holds.releaseNote': 'Note (optional)',
    'p4dp.holds.empty': 'No legal holds.',
    'p4dp.holds.showReleased': 'Show released holds',
    'p4dp.holds.create': 'Place hold',
    'p4dp.holds.created': 'Legal hold placed.',
    'p4dp.holds.releasedToast': 'Legal hold released.',
    'p4dp.holds.fromFind': 'The hold will cover the ticked records ({members} people, {visits} visits).',
    'p4dp.holds.noRecords': 'Use Find a person to choose the records, then place the hold.',
    'p4dp.retention.title': 'Retention',
    'p4dp.retention.help': 'How long each kind of data is kept before CloudSign deletes it.',
    'p4dp.retention.col.what': 'What is kept',
    'p4dp.retention.col.module': 'Area',
    'p4dp.retention.col.period': 'Kept for',
    'p4dp.retention.col.where': 'Set at',
    'p4dp.retention.days': '{days} days',
    'p4dp.retention.varies': 'Varies by site or group',
    'p4dp.retention.forever': 'Until deleted by hand',
    'p4dp.retention.scope.tenant': 'Organisation settings',
    'p4dp.retention.scope.site': 'Site settings',
    'p4dp.retention.scope.group': 'Group settings',
    'p4dp.retention.scope.platform': 'Platform settings',
    'p4dp.retention.change': 'Change',
    'p4dp.retention.changeFor': 'Change {what}',
    'p4dp.retention.runs': 'Recent clean-ups',
    'p4dp.retention.run.module': 'Area',
    'p4dp.retention.run.action': 'Action',
    'p4dp.retention.run.when': 'When',
    'p4dp.retention.run.deleted': 'Deleted',
    'p4dp.retention.noRuns': 'No clean-ups have run yet.',
    'p4dp.retention.noRules': 'No retention rules reported.',
    'p4dp.requests.title': 'Requests from people',
    'p4dp.requests.help': 'Access, correction, erasure and stop-marketing requests. Deciding on them arrives with self-service requests.',
    'p4dp.requests.status': 'Show',
    'p4dp.requests.status.open': 'Open',
    'p4dp.requests.status.approved': 'Approved',
    'p4dp.requests.status.refused': 'Refused',
    'p4dp.requests.status.completed': 'Completed',
    'p4dp.requests.status.all': 'All',
    'p4dp.requests.kind.access': 'See my data',
    'p4dp.requests.kind.rectification': 'Correct my data',
    'p4dp.requests.kind.erasure': 'Erase my data',
    'p4dp.requests.kind.stop_marketing': 'Stop marketing',
    'p4dp.requests.col.ref': 'Reference',
    'p4dp.requests.col.kind': 'Request',
    'p4dp.requests.col.name': 'Name',
    'p4dp.requests.col.received': 'Received',
    'p4dp.requests.col.due': 'Due',
    'p4dp.requests.daysLeft': '{days} days left',
    'p4dp.requests.overdue': '{days} days overdue',
    'p4dp.requests.empty': 'No requests.',
};
//# sourceMappingURL=w28.js.map